export default {
  API_HOST: 'http://207.154.220.54:9002',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
}